var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M65.625 100l9.375-9.375-40.625-40.625 40.625-40.625-9.375-9.375-50 50 50 50z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }